export const OAuthSettings = {
    appId: '2671d95e-5755-460b-8967-abe4747751b2',
    scopes: [
        "user.read",
        "calendars.read",
        'group.readwrite.all',
        'user.readwrite.all'
    ],
    authority: 'https://login.microsoftonline.com/NETORG465099.onmicrosoft.com/'
};
